import {Component, Input} from '@angular/core';
import {DiscountDTO} from '../../../model/discountDTO';
import {CurrencyService} from '../../../services/currency-service';

@Component({templateUrl: './discount-price.component.html', selector: 'app-discount-price'})
export class DiscountPriceComponent {

  @Input() discount: DiscountDTO;
  @Input() amount: number;

  constructor(public service: CurrencyService) {
  }

}
